import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls back to top on every route change (BrowserRouter doesn't do it by itself)
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
